<template>
    <div class="custom-tables">
        <CFTitle title="18. Indicatori prestabiliți"></CFTitle>
        <p class="subtitle">Indicatori prestabiliți de rezultat</p>
        <b-table responsive striped hover :fields="fieldsRezultat" show-empty>
            <template #empty>
                <span class="small-item-table">Indicatori prestabiliți de rezultat: N/A</span>
            </template>
        </b-table>
		<p class="mb-5">Indicatorii de rezultat, reprezintă rezultatele directe / avantajele pe care le obțin beneficiarii, și a căror valoare se măsoară <strong>la sfârșitul perioadei de durabilitate</strong>, conform contractului de finanțare (începe în prima zi <strong>după finalizarea perioadei de implementare</strong>).</p>
        <p class="subtitle">Indicatori prestabiliți de realizare</p>
        <b-table responsive striped hover :fields="fieldsRealizare" :items="itemsRealizare">
            <template v-slot:cell(crt)="data">
                <span class="small-item-table">{{ Number(data.index) + 1 }}</span>
            </template>
            <template v-slot:cell(name)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(um)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(year)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(total)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(women)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(men)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(developed)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(undeveloped)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
        </b-table>
		<p class="mb-2">Indicatorii de realizare, fac referire la activitățile care sunt finanțate și a căror valoare țintă se măsoară la <strong>sfârșitul perioadei de implementare</strong>.</p>
	</div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import { BFormRadio, BTable} from "bootstrap-vue";
    export default {
        name: "CFIndicatoriPrestabiliti",
        components: {
            CFTitle,
            BFormRadio,
            BTable
        },
        props:{
            data: {
                type: Object,
                default: null
            },
            states: null,
            m3GrantApplication: {
                type: Object,
                default: null
            },
        },
        data() {
            return {
                completed: false,
                fieldsRezultat: [
                    {
                        key: 'crt',
                        label: 'Nr. Crt.',
                        thClass: 'fixed-width'
                    },
                    {
                        key: 'name',
                        label: 'Denumire indicator',
                        thClass: 'fixed-width-title'
                    },
                    {
                        key: 'um',
                        label: 'Unitate măsură',
                        thClass: 'fixed-width-um'
                    },
                    {
                        key: 'value',
                        label: 'Valoare de referință',
                    },
                    {
                        key: 'year',
                        label: 'Anul de referință',
                    },
                    {
                        key: 'total',
                        label: 'Total',
                        thClass: 'fixed-width-um'
                    },
                    {
                        key: 'women',
                        label: 'Femei',
                        thClass: 'fixed-width-um'
                    },
                    {
                        key: 'men',
                        label: 'Bărbați',
                        thClass: 'fixed-width-um'
                    },
                    {
                        key: 'developed',
                        label: 'Regiuni dezvoltate',
                        thClass: 'fixed-width-region'
                    },
                    {
                        key: 'undeveloped',
                        label: 'Regiuni mai puțin dezvoltate',
                        thClass: 'fixed-width-region'
                    },

                ],
                itemsRezultat: [],
                fieldsRealizare: [
                    {
                        key: 'crt',
                        label: 'Nr. Crt.',
                        thClass: 'fixed-width'
                    },
                    {
                        key: 'name',
                        label: 'Denumire indicator',
                        thClass: 'fixed-width-title'
                    },
                    {
                        key: 'um',
                        label: 'Unitate măsură',
                        thClass: 'fixed-width-um'
                    },
                    {
                        key: 'year',
                        label: 'Anul de referință',
                    },
                    {
                        key: 'total',
                        label: 'Total',
                        thClass: 'fixed-width-um'
                    },
                    {
                        key: 'women',
                        label: 'Femei',
                        thClass: 'fixed-width-um'
                    },
                    {
                        key: 'men',
                        label: 'Bărbați',
                        thClass: 'fixed-width-um'
                    },
                    {
                        key: 'developed',
                        label: 'Regiuni dezvoltate',
                        thClass: 'fixed-width-region'
                    },
                    {
                        key: 'undeveloped',
                        label: 'Regiuni mai puțin dezvoltate',
                        thClass: 'fixed-width-region'
                    },

                ],
                itemsRealizare: [],
                developedRegion: '-',
                undevelopedRegions: '-'
            }
        },
        mounted() {
            this.$store.dispatch('finantare/addToProgress', 'Indicatori prestabiliti');
            this.getDevelopedRegion()
            this.getUndevelopedRegions()
            if(this.data && this.data.m3_project && this.data.m3_project.indicators && this.data.m3_project.indicators.indicators){
                /*if(this.data.m3_project.indicators.indicators.result){
                    this.itemsRezultat.push({
                        crt: '1',
                        name: this.data.m3_project.indicators.indicators.result.title,
                        um: 'Intreprinderi',
                        value: '1',
                        year: '2026',
                        total: this.data.m3_project.indicators.indicators.result.number,
                        women: 'N/A',
                        men: 'N/A',
                        developed: this.developedRegion,
                        undeveloped: this.undevelopedRegions
                    },)
                }*/
                if(this.data.m3_project.indicators.indicators.achievement){
                    this.itemsRealizare.push(
                        {
                            crt: '1',
                            name: 'Investiție productivă: ' + this.data.m3_project.indicators.indicators.achievement.title,
                            um: 'Intreprinderi',
                            year: '2026',
                            total: this.data.m3_project.indicators.indicators.achievement.number,
                            women: 'N/A',
                            men: 'N/A',
                            developed: this.developedRegion,
                            undeveloped: this.undevelopedRegions
                        },
                        {
                            crt: '2',
                            name: 'Investiție productivă: Număr de întreprinderi care primesc granturi',
                            um: 'Intreprinderi',
                            year: '2026',
                            total: '1',
                            women: 'N/A',
                            men: 'N/A',
                            developed: this.developedRegion,
                            undeveloped: this.undevelopedRegions
                        },
                        {
                            crt: '3',
                            name: 'Număr de întreprinderi sprijinite pentru pregătirea unei redresări verzi, digitale și rezilientă a economiei',
                            um: 'Intreprinderi',
                            year: '2026',
                            total: '1',
                            women: 'N/A',
                            men: 'N/A',
                            developed: this.developedRegion,
                            undeveloped: this.undevelopedRegions
                        },
                    )
                }
            }
        },
        methods: {
            getDevelopedRegion(){
                if(this.data && this.data.m3_project && this.data.m3_project.location_address && this.data.m3_project.location_address.length > 0)
                    this.data.m3_project.location_address.forEach(location => {
                        if(location.region === 'București - Ilfov')
                            this.developedRegion = location.region
                    })

            },
            getUndevelopedRegions(){
                this.undevelopedRegions = '';
                let regions = [];
                if(this.data && this.data.m3_project && this.data.m3_project.location_address && this.data.m3_project.location_address.length > 0) {
                    this.data.m3_project.location_address.forEach(location => {
                        if(location.region !== 'București - Ilfov')
                            regions.push(location.region)
                    })

                    regions.filter((v, i, a) => a.indexOf(v) === i).forEach(region => {
                        this.undevelopedRegions = this.undevelopedRegions + region + ', '
                    })

                    if(this.undevelopedRegions)
                        this.undevelopedRegions = this.undevelopedRegions.substring(0, this.undevelopedRegions.length - 2)
                }

                this.undevelopedRegions = !this.undevelopedRegions ? '-' : this.undevelopedRegions
            },

        }
    }
</script>
<style scoped>
.subtitle{
    margin-top: 20px;
    font-weight: bold;
}
.small-item-table{
    display: flex;
    width: 100%;
    justify-content: center
}
table >>> thead th, table >>> tr td{
    border: 1px solid #c9c9c9 !important;
}
</style>
<style>

    table .fixed-width{
        width: 6%;
    }
    table .fixed-width-title{
        width: 20%;
    }
    table .fixed-width-um{
        width: 4%;
    }
    table .fixed-width-region{
        width: 17.5%;
    }
</style>
